// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1u6fZ","footer":"ModalFilter_footer__38A5V"};